import { createStyles } from '@mantine/emotion';

export const INDENT_SIZE = 37;
export const LEFT_SECTION_WIDTH = 300;

export const BORDER_COLOR = '#E9ECEF';
export const HEADER_BG = '#F8F9FA';
export const TEXT_COLOR = '#212529';
export const FONT_SIZE = '12px';
export const LINE_HEIGHT = '20px';
export const CELL_PADDING = '7.5px 8px';
export const TEXT_COLOR_SECONDARY = '#495057';

export const DISABLED_TEXT_COLOR = '#ADB5BD';

export const useTableStyles = createStyles(() => ({
  borderBottomRight: {
    borderRight: `1px solid ${BORDER_COLOR}`,
    borderBottom: `1px solid ${BORDER_COLOR}`
  },
  borderRight: {
    borderRight: `1px solid ${BORDER_COLOR}`
  },
  borderBottom: {
    borderBottom: `1px solid ${BORDER_COLOR}`
  },
  leftSticky: {
    position: 'sticky',
    left: '0',
    zIndex: 100
  }
}));
